import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { TrendUp, X, ArrowRight } from "@phosphor-icons/react";
import { formatEUR, formatDate } from "@/lib/constants";

// Dashboard-Hinweis: Mieterhöhungen, die jetzt bzw. in den nächsten 30 Tagen möglich werden.
export default function RentIncreaseAlerts() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/rent-increase/dashboard-alerts").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d?.items?.length) return null;
  const dismiss = async (it) => {
    setD((x) => ({ ...x, items: x.items.filter((y) => y.tenancy_id !== it.tenancy_id) }));
    await api.post("/rent-increase/dashboard-alerts/dismiss", { tenancy_id: it.tenancy_id, earliest_send_date: it.earliest_send_date }).catch(() => {});
  };
  const now = d.items.filter((i) => i.status === "possible_now").length;
  return (
    <div className="bg-emerald-50/60 border border-emerald-200 rounded-md overflow-hidden" data-testid="dashboard-rent-increase-alerts">
      <div className="flex flex-wrap items-center gap-2 px-4 py-2 border-b border-emerald-200 bg-emerald-100/50">
        <TrendUp size={16} className="text-emerald-800" />
        <h2 className="text-sm font-semibold text-emerald-900">Mieterhöhung möglich</h2>
        <span className="text-xs text-emerald-800" data-testid="ri-alert-summary">
          {now} jetzt · {d.items.length - now} in den nächsten 30 Tagen · bis zu +{formatEUR(d.potential_eur_month)} / Monat
        </span>
        <Link to="/mieterhoehungen/assistent" className="ml-auto text-xs font-medium text-emerald-800 hover:text-emerald-950 inline-flex items-center gap-1" data-testid="ri-alert-open-wizard">
          Zum Assistenten <ArrowRight size={12} />
        </Link>
      </div>
      <div className="divide-y divide-emerald-100 max-h-56 overflow-y-auto">
        {d.items.slice(0, 8).map((it) => (
          <div key={it.tenancy_id} className="flex items-center gap-3 px-4 py-2 text-sm" data-testid={`ri-alert-${it.tenancy_id}`}>
            <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${it.status === "possible_now" ? "bg-emerald-200 text-emerald-900" : "bg-amber-100 text-amber-900"}`}>
              {it.status === "possible_now" ? "Jetzt möglich" : `ab ${formatDate(it.earliest_send_date)}`}
            </span>
            <Link to={`/mietverhaeltnisse/${it.tenancy_id}?tab=mieterhoehung`} className="flex-1 min-w-0 truncate text-slate-800 hover:underline" data-testid={`ri-alert-link-${it.tenancy_id}`}>
              <span className="font-mono text-xs mr-2">{it.contract_number}</span>{it.property_name}{it.unit_number ? ` · ${it.unit_number}` : ""}
            </Link>
            <span className="tabular-nums text-xs text-slate-700">{formatEUR(it.current_rent)} → <b className="text-emerald-800">{formatEUR(it.new_rent)}</b></span>
            <span className="text-xs text-slate-500 hidden md:inline">wirksam {formatDate(it.earliest_effective_date)}</span>
            <button type="button" onClick={() => dismiss(it)} className="p-1 rounded hover:bg-emerald-200 text-emerald-800" title="Ausblenden" data-testid={`ri-alert-dismiss-${it.tenancy_id}`}><X size={14} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
